
import {
    defineComponent, watch, ref, Ref,
    computed, PropType
} from 'vue';
import { isCNServer, isRuServer } from '@/util/location';
import { format } from '@/methods/date';
import { TemperatureSearchData } from './all.type';
import './index.less';

export default defineComponent({
    props: {
        searchData: {
            type: Object as PropType<TemperatureSearchData>,
            required: true
        }
    },
    setup(props, { emit }) {
        // 初始化搜索栏数据
        const formData: Ref<TemperatureSearchData> = ref({
            startTime: '',
            endTime: '',
            status: '',
            unit: 'fahrenheit'
        });
        watch(computed(() => props.searchData), () => {
            formData.value = { ...props.searchData };
        }, {
            immediate: true
        });

        watch(computed(() => formData.value.unit), () => {
            emit('unitChange', formData.value.unit);
        });

        const StatusOptions = [
            {
                label: WordList.SelectAll,
                value: ''
            }, {
                label: WordList.ProperAllTextAbnormal,
                value: 'abnormal'
            }, {
                label: WordList.ProperAllTextNormal,
                value: 'normal'
            }, {
                label: WordList.ProperAllTextLow,
                value: 'low'
            }
        ];
        const UnitOptions = [
            {
                label: '℃',
                value: 'celsius'
            }, {
                label: '℉',
                value: 'fahrenheit'
            }
        ];

        // 返回搜索条件
        const updateToList = () => {
            const param = { ...formData.value };
            param.startTime = format(param.startTime, 'YYYY-MM-DD HH:mm:ss');
            param.endTime = format(param.endTime, 'YYYY-MM-DD HH:mm:ss');
            emit('updateToList', param);
        };

        return {
            isCNServer,
            isRuServer,
            formData,
            updateToList,
            emit,
            StatusOptions,
            UnitOptions
        };
    }
});
